import { render, staticRenderFns } from "./EmailConfirmationPending.vue?vue&type=template&id=2418765e"
import script from "./EmailConfirmationPending.vue?vue&type=script&lang=js"
export * from "./EmailConfirmationPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports